import '../styles/App.scss';
import { NavLink, Link } from 'react-router-dom';
function Nav() {
  const imgFatia = require('../assets/fatia.jpeg');
  
  return (
    <div className="container-nav">
      <Link to="/" style={{ textDecoration: 'none' }}>
        <div className="head-nav">
          <img src={imgFatia} alt="fatia" className="img-laods" />
          <p className="title">Fatia Marwa Nastitie</p>
          <p className="desc">Data Scientist</p>
          <p className="desc-new">
            Mid-level data scientist with 4 years experience across healthcare, telecom, and tech industry. Specialzing in analytics
            and machine learning. I've delivered a PySpark churn prediction model that boosted revenue by 11% (~$200K monthly uplift) 
            and built clinical risk models that improved patient outcomes by over 12%. I enjoy building automated ML pipelines, ensuring strong data governance, 
            and turning complex datasets into clear, actionable insights. I’m excited to apply my experience to help teams make smarter, data-driven decisions and drive measurable growth.
          </p>
        </div>
      </Link>
      <div className="nav-links">
        <NavLink exact to="/" activeClassName="active">Portfolio</NavLink>
        <NavLink exact to="/contact" activeClassName="active">Find me on</NavLink>
        <a href="https://drive.google.com/file/d/1z5aYn1qSrZgtgRD6M0KY2ddjfcGRig8J/view?usp=sharing" target="_blank" rel="noreferrer">Resume</a>
      </div>
    </div>
  );
}

export default Nav;
